// extracted by mini-css-extract-plugin
export default {"checkboxFilter":"promotion-media-filter-checkbox_checkboxFilter__zpqiW","stackCheckbox":"promotion-media-filter-checkbox_stackCheckbox__o+OpN"};